// extracted by mini-css-extract-plugin
export default {"placeHolderShimmer":"AUm9kxGWl_0uZ8E3Mv9c"};